import { IRoi, IRoiChange, IRoiChangeResponse, IRoiResponse } from './index';

export const mapListOfInvoices = (invoices: IRoiChangeResponse): IRoiChange[] => {
    return invoices.results.sort((a, b) => (a.roiInvoiceLineNo > b.roiInvoiceLineNo) ? 1 : -1).map((r) => ({
                                            invoiceLineNo: r.invoiceLineNo,
                                            invoiceNumber: r.invoiceNumber,
                                            invoiceNo: r.invoiceNo,
                                            roiInvoiceLineNo: r.roiInvoiceLineNo,
                                            invoiceId: r.invoiceNumber,
                                            uid: r.uid,
                                            etag: r.etag,
                                            reasons: r.reasons,
                                        }));
};

export const mapListOfCommodities = (commodities: IRoiChangeResponse): IRoiChange[] => {
    return commodities.results.sort((a, b) => (a.roiGoodLineNo > b.roiGoodLineNo) ? 1 : -1).map((r) => ({
                                            goodLineNo: r.goodLineNo,
                                            roiGoodLineNo: r.roiGoodLineNo,
                                            invoiceNo: r.invoiceNo,
                                            roiInvoiceLineNo: r.roiInvoiceLineNo,
                                            uid: r.uid,
                                            etag: r.etag,
                                            reasons: r.reasons,
                                            invoiceId: r.invoiceId,
                                            invoiceNumber: r.invoiceNumber
                                        }));
};

export const mapRoiHeaderResponse = (response: IRoiResponse): IRoi => {
    return {
                cadTransactionNumber: response.cadTransNo,
                comments: response.notes,
                roiTransactionNumber: response.roiTransactionNumber,
                reasons: response.reasons,
                status: response.status,
            };
};
